<template>
  <ListView
    modelName="ShelfNo"
    perm="master.menu_shelf_no"
    :items.sync="items"
    :params.sync="params"
    title="menu_shelf_no"
    :key="$route.fullPath"
    :sortOptions="sortOptions"
    ref="mainList"
    :tabs="['基本情報']"
    gridKey="ShelfNo"
    :gridCaptions="['状態', 'ワークフロー','倉庫',  '商品',  'SKU', '棚番号', '初回保存日', '初回保存者', '最終更新日', '最終更新者']"
    :gridWidths="[100, 180, 150, 150, 150, 150, 150, 150, 150, 150]"
    :onCreate="onCreate"
    :importQuery="importQuery"
    :exportQuery="exportQuery"
    :comparer="(a,b)=>a.id == b.id"            
    tooltip="ピッキングリスト・棚卸指示書に表示される棚番号を登録します。"
    :popup="popup"    
  >
    <!-- 明細項目の配置 -->
    <GridItem slot="grid0" slot-scope="{ item }"><Badge :value="item.state" list="masterBaseStatus"/></GridItem>
    <GridItem slot="grid1" slot-scope="{ item, index }"><Workflow :item="item" :index="index" @updated="onWorkflow" :perm="$refs.mainList.perm+'.approve'"/></GridItem>    
    <!-- <GridItem slot="grid2" slot-scope="{ item }">{{ item.warehouse.code }}</GridItem> -->
    <GridItem slot="grid2" slot-scope="{ item }">{{ item.warehouse.name }}</GridItem>    
    <!-- <GridItem slot="grid4" slot-scope="{ item }">{{ item.commodity.code }}</GridItem> -->
    <GridItem slot="grid3" slot-scope="{ item }">{{ item.commodity.name }}</GridItem>
    <!-- <GridItem slot="grid6" slot-scope="{ item }">{{ item.sku ? item.sku.code : '' }}</GridItem> -->
    <GridItem slot="grid4" slot-scope="{ item }">{{  item.sku ? item.sku.name : '' }}</GridItem>
    <GridItem slot="grid5" slot-scope="{ item, index, listView}" :func="true" @click="listView.onOpenDialogByIndex(index)">{{ item.shelfNo }}</GridItem>
    <GridItem slot="grid6" slot-scope="{ item }">{{ item.initialSavedOn | timestamp }}</GridItem>
    <GridItem slot="grid7" slot-scope="{ item }">{{ item.initialSavedBy | user }}</GridItem>
    <GridItem slot="grid8" slot-scope="{ item }">{{ item.lastUpdatedOn | timestamp }}</GridItem>
    <GridItem slot="grid9" slot-scope="{ item }">{{ item.lastUpdatedBy | user  }}</GridItem>
    <!-- リストメニューの配置 -->
    <template slot="menu" slot-scope="{ listView }"><ListViewMenuBar :listView="listView"/></template>
    <!-- 検索パネルーの配置 -->
    <template slot="search" slot-scope="{ params, handler, listView }">
      <Search :listView="listView">
        <!-- <FilterBox title="商品コード" :value.sync="params.commodityCode" @click="handler" /> -->
        <!-- <FilterBox title="商品名称" :value.sync="params.commodityName" @click="handler" />         -->
        <!-- <FilterBox title="倉庫コード" :value.sync="params.warehouseCode" @click="handler" /> -->
        <!-- <FilterBox title="SKUコード" :value.sync="params.skuCode" @click="handler" /> -->
        <FilterBox title="棚番号" :value.sync="params.shelfNo" @click="handler" />          
        <AtcCounterpart title="倉庫" :value.sync="params.warehouse" :needsWarehouse="true" @changed="handler" />        
        <AtcCommodity title="商品" :value.sync="params.commodity" @changed="handler" />
        <AtcSKU title="SKU" :value.sync="params.sku" :commodity="params.commodity" @update:value="handler" />                      
        <Calendar title="初回保存日(From)" :value.sync="params.initialSavedOnFrom" :deletable="true" @changed="handler" />
        <Calendar title="初回保存日(To)" :value.sync="params.initialSavedOnTo" :deletable="true" @changed="handler" />
        <Calendar title="最終更新日(From)" :value.sync="params.lastUpdatedOnFrom" :deletable="true" @changed="handler" />
        <Calendar title="最終更新日(To)" :value.sync="params.lastUpdatedOnTo" :deletable="true" @changed="handler" />
        <!-- <ComboBox title="所有者" :value.sync="params.holder" list="user" @changed="handler" /> -->
        <AutoComplete title="所有者" :value.sync="params.holder" list="user" @changed="handler" />          
        <ComboBox title="状態" :value.sync="params.state" list="masterBaseStatus" @changed="handler" />        
      </Search>
    </template>
    <!-- エディタの配置 -->
    <template slot="sideEditor" slot-scope="{ listView }">
      <Editor :item="listView.selected" :owner="listView" :tabs="['基本情報','ワークフロー','更新履歴']" :tabTooltips="[,null,null]">
        <!-- 基本情報タブ -->
        <template slot="tab0" slot-scope="{ editor, item }">
          <EditPanel>
            <!-- 基本情報タブ 左側 -->
            <template slot="left">
              <AtcCounterpart title="倉庫" :value.sync="item.warehouse" :needsWarehouse="true" :editor="editor" :required="true" tooltip="棚番号を登録する倉庫を指定します。"/>              
              <!-- <ComboBox title="ワークフロー" :value.sync="item.workflowId" :editor="editor" list="workflow_masterBase" :required="workflowRequired(item)" :enabled="workflowRequired(item)" :nullValue="0" /> -->
              <AtcCommodity title="商品" :value.sync="item.commodity" :enabled="listView.isInsertMode && popup ==null" :editor="editor" :required="true" tooltip="棚番号を登録する商品を指定します。" />
              <AtcSKU title="SKU" :value.sync="item.sku" :editor="editor" :commodity="item.commodity" tooltip="棚番号を登録するSKUを指定します。" />
              <TextBox title="棚番号" :value.sync="item.shelfNo" :editor="editor" :required="true" length="25" tooltip="棚番号を指定します。棚番号はピッキングリスト・棚卸指示書に表示されます。" />
            </template>
            <!-- 基本情報タブ 右側 -->
            <template slot="right">
              <!-- <TextBox title="状態" :value="item.state | masterBaseStatus" :editor="editor" :enabled="false" />
              <TextBox title="所有者" :value="item.holder | user" :editor="editor" :enabled="false" />
              <TextBox title="初回保存日" :value="item.initialSavedOn | timestamp" :editor="editor" :enabled="false" />
              <TextBox title="初回保存者" :value="item.initialSavedBy | user" :editor="editor" :enabled="false" />
              <TextBox title="最終更新日" :value="item.lastUpdatedOn | timestamp" :editor="editor" :enabled="false" />
              <TextBox title="最終更新者" :value="item.lastUpdatedBy | user" :editor="editor" :enabled="false" /> -->
              <TextBox title="最終更新日" :value="$api.perms.getLastUpdateLabel(item)" :enabled="false" tooltip="最後に更新した日付が表示されます。" />                      
              <ComboBox title="ワークフロー" :value.sync="item.workflowId" :editor="editor" list="workflow_masterBase" :required="$api.perms.hasWorkflow('masterBase')" :enabled="$api.perms.hasWorkflow('masterBase') && $api.perms.isEntryStatus(item)" :nullValue="0" tooltip="マスタ登録用のワークフローを指定します。" />
              <TextBox title="状態" :value="$api.perms.getWorkflowStateLabel(item)" :enabled="false" tooltip="現在のワークフローの状態が表示されています。" />                  
            </template>
          </EditPanel>
        </template>
        <!-- ワークフロータブ -->
        <template slot="tab1" slot-scope="{ item, editor }">
          <MessageList class="cx_matter_message" :item="item" :editor="editor" />
        </template>
        <!-- 更新履歴タブ -->
        <template slot="tab2" slot-scope="{ item }">
          <AuditLog :auditName="item.auditName" :auditNo="item.auditNo" />
        </template>
      </Editor>
    </template>
  </ListView>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class ShelfNoView extends Vue {
  public items: Common.ShelfNo[] = new Array(0);
  public params: Common.ShelfNoQuery = new Common.ShelfNoQuery();
  public importQuery = new Common.ImportQuery('棚番号', 'ShelfNo');
  public exportQuery = new Common.ExportQuery('棚番号', this.params);
  @Prop() public auditNo:string;
  @Prop() public commodity:Common.Commodity;
  @Prop({default:null}) public popup: Components.PopupEditor;  

  public sortOptions: any = [
    { value: 'State', text:'状態' },
    { value: 'warehouse', text: '倉庫'},
    { value: 'commodity', text: '商品'},
    { value: 'sku', text: 'SKU' },
    { value: 'shelfNo', text: '棚番号' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
  ];

  public created() {
    // 検索条件を設定する
    if(this.auditNo) {
      this.params.auditNo = this.auditNo;
      this.params.state = null;
    }

    if (this.commodity){
      this.params.commodity = this.commodity;
    }
    
    if (!this.auditNo && !this.commodity){
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
    }
    this.$api.formatter.ensureListLoaded('workflow_masterBase');          
  }
  
  public async onCreate(obj: Common.ShelfNo) {
    const workflows = this.$api.formatter.getOptions('workflow_masterBase');
    if (workflows.length > 0) obj.workflowId = workflows[0].value;
    if (this.popup && this.commodity) obj.commodity = this.commodity;        
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
  }

  public workflowRequired(item: Common.ShelfNo):boolean {
    if(item.state != Common.MasterBaseStatus.NotPosted) return false;
    var workflows = this.$api.formatter.getOptions('workflow_masterBase');
    return workflows.length > 0;
  }
}
</script>
